<template>
    <data-table :columns="fields" :items="permissions">
        <template #description="{ item }">
            <td class="align-middle">
                <span v-c-tooltip="item.name">
                    {{ item.description }}
                </span>
            </td>
        </template>
        <template #systemUser="{ item }">
            <td class="align-middle text-center">
                <span
                    v-if="item['systemUser']"
                    class="d-inline-flex align-items-center justify-content-center bg-success rounded-circle"
                    style="width: 24px; height: 24px"
                >
                    <icon class="text-black-100" icon="cil-check-alt" />
                </span>
            </td>
        </template>
        <template #admin="{ item }">
            <td class="align-middle text-center">
                <span
                    v-if="item['admin']"
                    class="d-inline-flex align-items-center justify-content-center bg-success rounded-circle"
                    style="width: 24px; height: 24px"
                >
                    <icon class="text-black-100" icon="cil-check-alt" />
                </span>
            </td>
        </template>
        <template #manager="{ item }">
            <td class="align-middle text-center">
                <span
                    v-if="item['manager']"
                    class="d-inline-flex align-items-center justify-content-center bg-success rounded-circle"
                    style="width: 24px; height: 24px"
                >
                    <icon class="text-black-100" icon="cil-check-alt" />
                </span>
            </td>
        </template>
        <template #user="{ item }">
            <td class="align-middle text-center">
                <span
                    v-if="item['user']"
                    class="d-inline-flex align-items-center justify-content-center bg-success rounded-circle"
                    style="width: 24px; height: 24px"
                >
                    <icon class="text-black-100" icon="cil-check-alt" />
                </span>
            </td>
        </template>
        <template #viewer="{ item }">
            <td class="align-middle text-center">
                <span
                    v-if="item['viewer']"
                    class="d-inline-flex align-items-center justify-content-center bg-success rounded-circle"
                    style="width: 24px; height: 24px"
                >
                    <icon class="text-black-100" icon="cil-check-alt" />
                </span>
            </td>
        </template>
    </data-table>
</template>
<script>
import DataTable from '@/Components/DataTable.vue';

export default {
    name: 'PermissionsTable',
    components: { DataTable },
    props: {
        permissions: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        fields() {
            return [
                { key: 'description', label: 'Description', sorter: false },
                {
                    key: 'systemUser',
                    label: 'System User',
                    _style: 'width: 100px; white-space: nowrap; text-align: center',
                    sorter: false,
                },
                {
                    key: 'admin',
                    label: 'Admin',
                    _style: 'width: 100px; white-space: nowrap; text-align: center',
                    sorter: false,
                },
                {
                    key: 'manager',
                    label: 'Manager',
                    _style: 'width: 100px; white-space: nowrap; text-align: center',
                    sorter: false,
                },
                {
                    key: 'user',
                    label: 'User',
                    _style: 'width: 100px; white-space: nowrap; text-align: center',
                    sorter: false,
                },
                {
                    key: 'viewer',
                    label: 'Viewer',
                    _style: 'width: 100px; white-space: nowrap; text-align: center',
                    sorter: false,
                },
            ];
        },
    },
};
</script>
